/*
Creating the channel supported currencies list
 */
'use strict';

var Link = require('../Link');
var ListItem = require('../ListItem');
function renderCurrencyListItems() {
	return {
		getCurrencyListItems: function render(config, deps) {
			var _ = deps.underscore;
			var currencies = config.CHANNEL_SETTINGS.currencies; // Currencies supported by the channel.

			return _.reduce(currencies, function(result, currency) {
				var currencyLink = new Link({
					labelRaw: currency,
					isVisible: true,
					value: currency,
					clickFunction: "changeCurrency('" + currency + "')"
				}).render(config, deps);
				result += new ListItem({
					linkComponent: currencyLink,
					className: config.defaultCurrency === currency ? 'selected' : ''
				}).render(config, deps);

				return result;
			}, '');
		}
	};
}

module.exports = {
	renderCurrencyListItems: renderCurrencyListItems
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/currency-list-items.js
// module id = 25
// module chunks = 0